import { render, staticRenderFns } from "./tendering.vue?vue&type=template&id=b0f3648e"
import script from "./tendering.vue?vue&type=script&lang=js"
export * from "./tendering.vue?vue&type=script&lang=js"
import style0 from "./tendering.vue?vue&type=style&index=0&id=b0f3648e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports